import React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { useCaseCollaboration } from './CaseCollaborationContext';
import { initialsForCollaborator } from './colors';

export default function CollaboratorInitials({ jurorId }) {
  const { getEditorsForJuror, getLiveStatesForJuror } = useCaseCollaboration();

  const collaborators = React.useMemo(() => {
    const bySession = new Map();

    for (const editor of getEditorsForJuror(jurorId)) {
      bySession.set(editor.sessionId, editor);
    }

    for (const state of getLiveStatesForJuror(jurorId)) {
      if (!bySession.has(state.sessionId)) {
        bySession.set(state.sessionId, state);
      }
    }

    return [...bySession.values()];
  }, [getEditorsForJuror, getLiveStatesForJuror, jurorId]);

  if (!collaborators.length) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        mb: 1,
      }}
    >
      {collaborators.map((person) => {
        const initials = initialsForCollaborator(
          person.email,
          person.displayName,
        );
        const tooltip = `${person.displayName}\n${person.email}`;

        return (
          <Tooltip key={person.sessionId || person.email} title={tooltip}>
            <Avatar
              sx={{
                width: 26,
                height: 26,
                fontSize: 11,
                fontWeight: 700,
                bgcolor: person.color,
                border: '2px solid #fff',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.12)',
              }}
            >
              {initials}
            </Avatar>
          </Tooltip>
        );
      })}
    </Box>
  );
}
